var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"directory-root",on:{"click":_vm.emitClicked}},[_c('v-icon',[_vm._v("mdi-folder-open")]),_vm._v(" "+_vm._s(_vm.name)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }